export const ISMOBILE = window.matchMedia('(max-width: 767.98px)').matches;
export const ISTABLET = window.matchMedia('(min-width: 768px)').matches
export const ISDESKTOP = window.matchMedia('(min-width: 992px)').matches;
export const ISLARGEDESKTOP = window.matchMedia('(min-width: 1280px)').matches;

export const MOBILE = '(max-width: 767.98px)';
export const TABLET = '(min-width: 768px)';
export const DESKTOP = '(min-width: 992px)';
export const LARGEDESKTOP = '(min-width: 1280px)';
